<template>
  <div class="OAImage">
    <sky-upload-img :value="imgData" :disabled="true" platform='oa-pri-oss'></sky-upload-img>
  </div>
</template>

<script>
export default {
  name: "OAImage",
  props: {
    scope: {
      default: null
    }
  },
  computed: {
    imgData() {
      return JSON.parse(this.scope.row.imgList);
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/OAColums/OAImage.vue